import PropTypes from 'prop-types';

import { Announcement, Card, TitleInput } from '@utilities';

import styles from './_index.module.scss';

const HeaderCard = ({ buildError, headerIcon, label, name, setName, type }) => {
  return (
    <Card className={styles['header-card']}>
      <div className={styles['header-card-title']}>
        {headerIcon && <div className={styles['header-card-icon']}>{headerIcon}</div>}
        <div className={styles['header-card-text-content']}>
          <h2>{`Welcome to the ${label} Builder`}</h2>
          <p>{`Select from the below prompts to define the focus of your ${label}.`}</p>
        </div>
      </div>
      {buildError && <Announcement text={buildError} variant="error" />}
      <TitleInput
        autoFocus
        onChange={setName}
        placeholder={`What do you want to call this ${type}?`}
        value={name}
      />
    </Card>
  );
};

HeaderCard.propTypes = {
  buildError: PropTypes.string,
  headerIcon: PropTypes.node,
  label: PropTypes.string,
  name: PropTypes.string,
  setName: PropTypes.func,
  type: PropTypes.string,
};

export default HeaderCard;
